import React from "react";

import { TagChip, type TagChipProps } from "./TagChip";
import type { Tag as TagValue } from "./TagTypes";

export type TagChipsProps = {
  tags: TagValue[];
  customTagRenderer?: (tag: TagValue, isActiveTag: boolean) => React.ReactNode;
  direction?: TagChipProps["direction"];
  className?: string;
  activeTagIndex?: number | null;
  setActiveTagIndex?: (index: number | null) => void;
  disabled?: boolean;
} & Omit<TagChipProps, "tagObj" | "onRemoveTag"> & {
    onRemoveTag: (id: string) => void;
  };

export const TagChips: React.FC<TagChipsProps> = ({
  tags,
  customTagRenderer,
  direction,
  className: _className,
  activeTagIndex,
  setActiveTagIndex: _setActiveTagIndex,
  disabled,
  onRemoveTag,
  ...tagChipProps
}) => {
  const renderTag = (tagObj: TagValue, index: number) => (
    <React.Fragment key={tagObj.id}>
      {customTagRenderer ? (
        customTagRenderer(tagObj, index === activeTagIndex)
      ) : (
        <TagChip
          tagObj={tagObj}
          isActiveTag={index === activeTagIndex}
          direction={direction}
          draggable={false}
          onRemoveTag={onRemoveTag}
          {...tagChipProps}
          disabled={disabled}
        />
      )}
    </React.Fragment>
  );

  return <>{tags.map((tagObj, index) => renderTag(tagObj, index))}</>;
};
